import React, { useState } from 'react';
import Form from 'react-bootstrap/Form';
import Card from 'react-bootstrap/Card';
import Button from 'react-bootstrap/Button';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import { Container } from 'react-bootstrap';



function Paas() {
  const [selectedOption, setSelectedOption] = useState('');

  const handleOptionChange = (event) => {
    setSelectedOption(event.target.value);
  };

  const handleLinkButtonClick = () => {
    let link = '';
    if (selectedOption === '7') {
      link = '../Pdf/PAAAS2024Avance1erTrimestre.pdf';
    } else if (selectedOption === '1') {link = '../Pdf/MIR20251ER.pdf';
            } else if (selectedOption === '2') {link = '../Pdf/MIR20252DO.pdf';
    } else if (selectedOption === '3') {link = '../Pdf/MIR2025ER.pdf';
    } else if (selectedOption === '4') {link = '../Pdf/MIR20254TO.pdf';





    }
    window.open(link, '_blank');
  };

  return (
<Container>
      <Row>
        <Col>
        <br></br><br></br><br></br><br></br>

          <Card>
            <Card.Body>
              <div style={{ maxWidth: '300px' }}>
            </div>              
            <Card.Text>MIR</Card.Text>
              <Form.Select
                aria-label="Default select example"
                value={selectedOption}
                onChange={handleOptionChange}
              >
                <option>- - -</option>
                <option value="1">2025 1ER TRIMESTRE</option>
                 <option value="2">2025 2DO TRIMESTRE</option>
                <option value="3">2025 3ER TRIMESTRE</option>
                <option value="4">2025 4TO TRIMESTRE</option>





              </Form.Select>
              <Button variant="primary" onClick={handleLinkButtonClick}>Ver</Button>
            </Card.Body>
          </Card>
        </Col>

      </Row>
      </Container>

  );
}

export default Paas